import { isLocalHostname } from '@/localDev';

// Developer-facing caption next to the wallet surface (Express Checkout
// Element) explaining wallet absences that are by design, so an integrating
// developer doesn't read them as a broken integration:
//
// A local origin (*.localhost, hosts-file alias over HTTP) has no DV
// certificate and is not a registered payment-method domain, so Apple Pay
// and Google Pay never render there. Link and Amazon Pay do.
//
// Hardcoded English like TestCardHint: only developers on local origins see
// this, and the i18n catalog's key-drift guard would force translation slots
// for 40+ locales.
export function WalletDevNote() {
  if (!isLocalHostname(window.location.hostname)) {
    return null;
  }
  return (
    <div class="sm-wallet-dev-note">
      <p>Some wallets like Apple Pay and Google Pay may not be available on local origins — they will appear on your live site served over HTTPS.</p>
    </div>
  );
}
